import { ResourcesPopin } from '@components/Resources/Update/ResourcesPopin';
import { KeyGetGetDayGanttTurnarounds, KeyGetGetSlotStrip, useMutationPostUpdateTurnaroundResources } from '@models';
import { Button } from '@mui/material';
import { useQueryClient } from 'react-query';
import { FlightTurnaroundDto, ImpactStatus, TurnaroundResourcesUpdateDto } from '@types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useBoolean } from '../../../hooks/useBoolean';

export const ResourcesSlotOccurenceButton = React.memo(function ResourcesSlotOccurenceButton({
    flight,
    disabled,
}: {
    flight?: FlightTurnaroundDto;
    disabled?: boolean;
}) {
    const { value: opened, setTrue: open, setFalse: close } = useBoolean(false);

    const queryClient = useQueryClient();
    const { mutateAsync: updateResources } = useMutationPostUpdateTurnaroundResources({
        onSuccess: ({ data }) => {
            close();
            queryClient.invalidateQueries(KeyGetGetDayGanttTurnarounds);
            queryClient.invalidateQueries(KeyGetGetSlotStrip);
        },
    });

    const onSubmitUpdateResources = useCallback(
        (newResources: { turnaroundResourcesUpdate: TurnaroundResourcesUpdateDto; propagate: boolean }) =>
            updateResources({
                turnaroundResourcesUpdateDto: newResources.turnaroundResourcesUpdate,
                propagate: newResources.propagate,
            }),
        [updateResources],
    );

    return (
        <>
            <Button
                variant="outlined"
                size="large"
                color="secondary"
                sx={{ width: '130px' }}
                onClick={open}
                disabled={disabled || flight?.impactStatus === ImpactStatus.CANCELLED}
            >
                <FormattedMessage id="schedule.resources" />
            </Button>
            {opened && flight && <ResourcesPopin flight={flight} onClose={close} onSubmit={onSubmitUpdateResources} />}
        </>
    );
});
